import w200 from "./bannerbg2_hy8l3p_c_scale,w_200.webp";
import w454 from "./bannerbg2_hy8l3p_c_scale,w_454.webp";
import w629 from "./bannerbg2_hy8l3p_c_scale,w_629.webp";
import w753 from "./bannerbg2_hy8l3p_c_scale,w_753.webp";
import w876 from "./bannerbg2_hy8l3p_c_scale,w_876.webp";
import w988 from "./bannerbg2_hy8l3p_c_scale,w_988.webp";
import w1100 from "./bannerbg2_hy8l3p_c_scale,w_1100.webp";
import w1203 from "./bannerbg2_hy8l3p_c_scale,w_1203.webp";
import w1295 from "./bannerbg2_hy8l3p_c_scale,w_1295.webp";
import w1391 from "./bannerbg2_hy8l3p_c_scale,w_1391.webp";
import w1394 from "./bannerbg2_hy8l3p_c_scale,w_1394.webp";
import w1400 from "./bannerbg2_hy8l3p_c_scale,w_1400.webp";

export default {
  "200w": w200,
  "388w": w454,
  "629w": w629,
  "753w": w753,
  "876w": w876,
  "988w": w988,
  "1100w": w1100,
  "1203w": w1203,
  "1295w": w1295,
  "1391w": w1391,
  "1394w": w1394,
  "1400w": w1400,
};
